export const searchProductV2PublicQuery = /* GraphQL */ `
  query SearchProductV2Public(
    $location: LocationInput
    $distance: Int
    $filter: SearchProductV2FilterInput
    $sort: SearchProductSortInput
    $nextToken: Int
    $limit: Int
  ) {
    searchProductV2(
      location: $location
      distance: $distance
      filter: $filter
      sort: $sort
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        id
        productID
        action
        brand
        category
        condition
        createdAt
        dimension {
          diameter
          height
          length
          unit
          width
        }
        dimensionRange {
          key
          min
          max
        }
        endDate
        externalSource
        externalUrl
        isPromoted
        location {
          lat
          lon
        }
        material
        model
        name
        pictures
        price {
          amount
          currency
          discountAmount
          discountRatio
        }
        progress
        provenance
        projectID
        quantity {
          number
          unit
        }
        ref
        byUserID
        shopID
        shop {
          company
          enableCart
          slug
        }
        slug
        source
        startDate
        updatedAt
      }
      total
      nextToken
    }
  }
`
